import { GameStatus } from '@sorare/core/src/__generated__/globalTypes';

export const isGameLive = (gameStatus?: GameStatus): boolean =>
  gameStatus === GameStatus.playing;

export const isGameStarted = (gameStatus: Nullable<GameStatus>): boolean =>
  gameStatus === GameStatus.played || gameStatus === GameStatus.playing;

export const isGameFinished = (gameStatus?: GameStatus): boolean =>
  gameStatus === GameStatus.played;

export const isGameLeft = (gameStatus: GameStatus): boolean =>
  gameStatus === GameStatus.scheduled || gameStatus === GameStatus.playing;

export const isGameScheduled = (gameStatus?: GameStatus): boolean =>
  gameStatus === GameStatus.scheduled;
